import { PushAllResponse } from "src/responses"
import { PrintMessageCommand } from "./PrintMessage"
import { StringNumber } from "src/types"

export interface PushStatusResponse extends Partial<PushAllResponse> {
	command: "push_status"
	sequence_id: StringNumber
}

export function isPushStatusCommand(
	data: PrintMessageCommand
): data is PushStatusResponse {
	return data.command === "push_status" && Object.keys(data).length < 40
}
